import React from 'react'

import { ItemIcon } from 'features/workflows/ItemIcon'

import { useStepIconState } from './useStepIconState'

type StepIconProps = Omit<
    React.ComponentPropsWithoutRef<typeof ItemIcon>,
    'icon' | 'iconUrl' | 'colorScheme'
> & {
    nodeType?: WorkflowSchemaNodeType
    node?: WorkflowActionConfig
}

export const StepIcon: React.FC<StepIconProps> = ({ nodeType, node, ...props }) => {
    const { icon, iconUrl, colorScheme } = useStepIconState({ nodeType, node })

    if (!nodeType) {
        return null
    }

    return <ItemIcon icon={icon} iconUrl={iconUrl} colorScheme={colorScheme} {...props} />
}
